module.exports = __webpack_public_path__ + "img/event2.e230eb86.jpg";